import { feeDivisor, maxFeePercentage } from 'constants/fees'
import { FeeType } from 'data/Auth/types'
import { OrderStyleType } from 'data/Order/types'
import webSocket from 'services/api/webSocket'

const calculateFee = (fees: FeeType | void, type: OrderStyleType, liquidity?: boolean) => {
  if (!fees) return maxFeePercentage

  if (type === webSocket.order.type.LIMIT && liquidity === true) {
    return fees.makerFee / feeDivisor
  }

  return fees.takerFee / feeDivisor
}

export default calculateFee
